import { Injectable, Input, Directive } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

import { Donation } from '../model/donation';
import { DonationFrequency } from '../model/donationfrequency';
import { DonationOption } from '../model/donationoption';
import { FrequencyOption } from '../model/frequencyoption';
import { PayResponse } from '../model/payresponse';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Directive()
@Injectable()
export class ControllerService {
  private model: Donation;

  frequencies: FrequencyOption[] = [
    new FrequencyOption(DonationFrequency.ONCE, 'donation.frequency_once'),
    new FrequencyOption(
      DonationFrequency.MONTHLY,
      'donation.frequency_monthly'
    ),
    new FrequencyOption(
      DonationFrequency.QUARTERLY,
      'donation.frequency_quarterly'
    ),
    new FrequencyOption(DonationFrequency.YEARLY, 'donation.frequency_yearly'),
  ];

  donationOptions_ONCE: DonationOption[] = [
    new DonationOption(20, '20'),
    new DonationOption(50, '50'),
    new DonationOption(100, '100'),
    new DonationOption(null, 'donation.option_other.name'),
  ];

  donationOptions_TRY_ONCE: DonationOption[] = [
    new DonationOption(150, '150'),
    new DonationOption(300, '300'),
    new DonationOption(700, '700'),
    new DonationOption(null, 'donation.option_other.name'),
  ];

  donationOptions_MORE: DonationOption[] = [
    new DonationOption(10, '10'),
    new DonationOption(20, '20'),
    new DonationOption(40, '40'),
    new DonationOption(null, 'donation.option_other.name'),
  ];

  donationOptions: DonationOption[] = [
    new DonationOption(10, '10'),
    new DonationOption(20, '20'),
    new DonationOption(40, '40'),
    new DonationOption(null, 'donation.option_other.name'),
  ];
  _donationOption: DonationOption;

  showCustomAmount = false;
  showKnownFromList = false;
  _donateOnce = false;
  _customAmount: number;
  _locale: string;
  _groupcode: string;

  currencies = {
    en_us: 'USD',
    en_ca: 'CAD',
    en_au: 'AUD',
    tr_tr: 'TRY',
    en_gb: 'GBP',
    nl_nl: 'EUR',
    it_it: 'EUR',
    fr_fr: 'EUR',
    de_de: 'EUR',
    es_es: 'EUR',
  };
  links = {
    en_us: 'https://www.magnumicecream.com/pleasureimagined',
    en_ca: 'https://www.magnumicecream.com/pleasureimagined',
    en_au: 'https://www.magnumicecream.com/pleasureimagined',
    tr_tr: 'https://www.magnumicecream.com/pleasureimagined',
    en_gb: 'https://www.magnumicecream.com/pleasureimagined',
    nl_nl: 'https://www.magnumicecream.com/pleasureimagined',
    it_it: 'https://www.magnumicecream.com/pleasureimagined',
    fr_fr: 'https://www.magnumicecream.com/pleasureimagined',
    de_de: 'https://www.magnumicecream.com/pleasureimagined',
    es_es: 'https://www.magnumicecream.com/pleasureimagined',
  };

  public lastPayResponse: PayResponse;

  constructor(private translate: TranslateService) {
    this.model = new Donation();
  }

  public getModel(): Donation {
    return this.model;
  }

  getTranslatedFrequency(): Observable<string> {
    const subject = new BehaviorSubject<string>('');
    this.translate
      .get('donation.frequency_' + this.frequency.toString().toLowerCase())
      .subscribe((res: string) => {
        subject.next(res);
      });
    return subject.asObservable();
  }

  getCurrency() {
    if (!this.currencies[this._locale]) {
      console.warn('returning default currency');
      return 'USD';
    }
    return this.currencies[this._locale];
  }

  getCurSym() {
    return getCurrencySymbol(this.getCurrency(), 'wide');
  }

  getLink() {
    // if (!this.links[this._locale]) {
    //   console.warn('returning default currency');
    //   return 'https://www.magnumicecream.com/pleasureimagined';
    // }
    return 'https://www.100weeks.nl';
  }

  configuredFrequencies() {
    if (this.donateOnce) {
      const result = this.frequencies.filter((donation, index) => index < 1);
      this.frequency = DonationFrequency.ONCE;
      return result;
    } else {
      return this.frequencies;
    }
  }

  /**
   * Getter / Setter donationOption
   */
  get customAmount(): number {
    return this._customAmount;
  }

  @Input('customAmount')
  set customAmount(customAmount: number) {
    this._customAmount = customAmount;
    this.model.payment.amount = customAmount;
  }

  /**
   * Getter / Setter donationOption
   */
  get donationOption(): DonationOption {
    return this._donationOption;
  }

  /**
   * Getter / Setter locale
   */
  get locale(): string {
    return this._locale;
  }

  set locale(locale: string) {
    this._locale = locale.toLowerCase();
  }

  /**
   * Getter / Setter groupcode
   */
  get groupcode(): string {
    return this._groupcode;
  }

  set groupcode(groupcode: string) {
    this._groupcode = groupcode.toUpperCase();
  }

  /**
   * Getter / Setter donateOnce
   */
  get donateOnce(): boolean {
    return this._donateOnce;
  }

  set donateOnce(donateOnce: boolean) {
    this._donateOnce = donateOnce;
  }

  @Input('donationOption')
  set donationOption(donationOption: DonationOption) {
    this._donationOption = donationOption;
    // this.model.payment.amount = donationOption.value;
  }

  /**
   * Getter / Setter frequency
   */
  get frequency(): DonationFrequency {
    return this.model.payment.frequency;
  }

  @Input('frequency')
  set frequency(frequency: DonationFrequency) {
    const isOnce = frequency === DonationFrequency.ONCE;
    const wasOnce = this.model.payment.frequency === DonationFrequency.ONCE;

    this.model.payment.frequency = frequency;

    if (isOnce !== wasOnce) {
      // Show
      this.donationOptions.length = 0;
      this.donationOption = null;
      if (frequency === DonationFrequency.ONCE) {
        if (this._locale === 'tr_tr') {
          this.donationOptions_TRY_ONCE.forEach((e) => {
            this.donationOptions.push(e);
          });
        } else {
          this.donationOptions_ONCE.forEach((e) => {
            this.donationOptions.push(e);
          });
        }
      } else {
        this.donationOptions_MORE.forEach((e) => {
          this.donationOptions.push(e);
        });
      }
    }
  }
}
